<div class="why-choose-positively-languages-reason">
  <div class="why-choose-positively-languages-reason__image">
    <img [src]="reasonImagePath" alt="Why to choose kaplan reason image" />
  </div>
  <div class="why-choose-positively-languages-reason__title">{{ reasonTitle }}</div>
  <div class="why-choose-positively-languages-reason__description">{{ reasonDescription }}</div>
</div>
